/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
// components
import CardPersonValidation from './CardPersonValidation';
import CardPersonalData from './CardPersonalData';
import CardContactData from './CardContactData';
import CardPreferredOffice from './CardPreferredOffice';
import CardDeclarationsData from './CardDeclarationsData';
import CardIdentityValidation from './CardIdentityValidation';
import FlowControlButtons from '../../molecules/FlowControlButtons/FlowControlButtons';
import Survey from '../../../containers/Survey/Survey';

import Modal from '../../organisms/Modal/Modal';
import CaseInfo from '../../molecules/CaseInfo/CaseInfo';

// assets
import { StyledWrapperCards } from './styles';

const PersonalData = (props) => {
  const {
    rut,
    serialNumber,
    firstName,
    lastName,
    maternalLastName,
    position,
    profession,
    workActivity,
    countryNationality,
    positionItems,
    professionItems,
    countryNationalityItems,
    workActivityItems,
    regionsWithOfficesItems,
    officesItems,
    phone,
    confirmationPhone,
    email,
    address,
    isValidPerson,
    taxDeclaration,
    canValidate,
    currentEdgeCase,
    preferredOffice,
    executiveCode,
    executive,
    executiveAttending,
    showIsRequiredPreviredAuthorization,
    isLoadingValidatePersonalData,
    isValidExecutiveCode,
    isLoadingFetchExecutive,
    isMobileDevice,
    previredAuthorization,
    isCompletedCardPersonValidation,
    isCompletedCardPersonalData,
    isCompletedCardContacData,
    isCompletedCardPreferredOffice,
    // isCompletedCardDeclarationsData,
    isVisiblePreferredOffice,
    isOpenModalAlreadyMemberRedirection,
    isOpenModalEdgeCase,
    isOpenModalAbandonmentSurvey,
    closeModalEdgeCase,
    closeModalAbandonmentSurvey,
    onChangePreferences,
    onChangeExecutiveCode,
    onChangeRegion,
    onChangeOffice,
    onChangeUserData,
    onValidatePerson,
    // isSavedPersonalData,
    onActionButtonCaseBorder,
    canContinueFlow,
    // onHandleShowModalAfterEvent,
    onContinueFlow,
    onCancelFlow,
  } = props;

  return (
    <StyledWrapperCards>
      <CardPersonValidation
        rut={rut}
        serialNumber={serialNumber}
        isValidPerson={isValidPerson}
        previredAuthorization={previredAuthorization}
        onChange={onChangeUserData}
        canValidate={canValidate}
        isCompletedCardPersonValidation={isCompletedCardPersonValidation}
        showIsRequiredPreviredAuthorization={showIsRequiredPreviredAuthorization}
        onValidatePerson={onValidatePerson}
        isMobileDevice={isMobileDevice}
        isLoadingValidatePersonalData={isLoadingValidatePersonalData}
        currentEdgeCase={currentEdgeCase}
        isOpenModalEdgeCase={isOpenModalEdgeCase}
        isOpenModalAlreadyMemberRedirection={isOpenModalAlreadyMemberRedirection}
        closeModalEdgeCase={closeModalEdgeCase}
        onActionButtonCaseBorder={onActionButtonCaseBorder}
      />
      <CardPersonalData
        rut={rut}
        firstName={firstName}
        lastName={lastName}
        maternalLastName={maternalLastName}
        position={position}
        profession={profession}
        workActivity={workActivity}
        professionItems={professionItems}
        positionItems={positionItems}
        workActivityItems={workActivityItems}
        countryNationality={countryNationality}
        countryNationalityItems={countryNationalityItems}
        disabled={!isValidPerson}
        onChange={onChangeUserData}
      />
      <CardContactData
        phone={phone}
        confirmationPhone={confirmationPhone}
        email={email}
        address={address}
        disabled={!isCompletedCardPersonalData}
        onChange={onChangeUserData}
      />
      {true && (
        <CardPreferredOffice
          regionsWithOfficesItems={regionsWithOfficesItems}
          officesItems={officesItems}
          preferredOffice={preferredOffice}
          isVisiblePreferredOffice={isVisiblePreferredOffice}
          isLoadingFetchExecutive={isLoadingFetchExecutive}
          isValidExecutiveCode={isValidExecutiveCode}
          isMobileDevice={isMobileDevice}
          disabled={!isCompletedCardContacData}
          executiveCode={executiveCode}
          onChangeExecutiveCode={onChangeExecutiveCode}
          executive={executive}
          executiveAttending={executiveAttending}
          onChange={onChangePreferences}
          onChangeRegion={onChangeRegion}
          onChangeOffice={onChangeOffice}
        />
      )}

      <CardDeclarationsData
        taxDeclaration={taxDeclaration}
        disabled={!isCompletedCardPreferredOffice}
        onChange={(field, value) => onChangeUserData(field, value)}
      />
      <CardIdentityValidation
        disabled={!(taxDeclaration.value.usa || taxDeclaration.value.chile)}
      />
      <FlowControlButtons
        nameButtonContinue="Continuar"
        canContinue={canContinueFlow}
        step="middle"
        // prefixContinue="line-claveunica"
        onContinueFlow={onContinueFlow}
        onCancelFlow={onCancelFlow}
      />
      {currentEdgeCase.title !== '' && isOpenModalEdgeCase && (
        <Modal
          isOpen={isOpenModalEdgeCase}
          closeModal={closeModalEdgeCase}
          unableToClose={currentEdgeCase.blocker}
          closeClickOutside={!currentEdgeCase.blocker}
          closeEscKey={!currentEdgeCase.blocker}
        >
          <CaseInfo
            edgeCase={currentEdgeCase}
            isMobile={isMobileDevice}
            onClickButton={onActionButtonCaseBorder}
          />
        </Modal>
      )}

      <Modal isOpen={isOpenModalAbandonmentSurvey} closeModal={closeModalAbandonmentSurvey}>
        <Survey type="abandonment" onCloseModal={closeModalAbandonmentSurvey} />
      </Modal>
    </StyledWrapperCards>
  );
};

PersonalData.defaultProps = {
  rut: { value: '', isValid: () => {}, errors: [] },
  serialNumber: { value: '', isValid: () => {}, errors: [] },
  firstName: { value: '', isValid: () => {}, errors: [] },
  lastName: { value: '', isValid: () => {}, errors: [] },
  maternalLastName: { value: '', isValid: () => {}, errors: [] },
  position: { value: {}, isValid: () => {}, errors: [] },
  profession: { value: {}, isValid: () => {}, errors: [] },
  // professions: [],
  phone: { value: '', isValid: () => {}, errors: [] },
  confirmationPhone: { value: '', isValid: () => {}, errors: [] },
  email: { value: '', isValid: () => {}, errors: [] },
  address: {},
  taxDeclaration: {
    value: { chile: false, world: false, usa: false },
    isValid: () => {},
    errors: [],
  },
  previredAuthorization: { value: false },
  isValidPerson: false,
  canContinueFlow: false,
  canValidate: false,
  isLoadingValidatePersonalData: false,
  onValidatePerson: () => null,
  onChangeUserData: () => null,
  onContinueFlow: () => null,
  onCancelFlow: () => null,
  onHandleShowModalAfterEvent: () => null,
};

PersonalData.propTypes = {
  rut: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  serialNumber: PropTypes.shape({}),
  firstName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  lastName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  maternalLastName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  position: PropTypes.shape({
    value: PropTypes.shape({
      codigo: PropTypes.string,
      descripcion: PropTypes.string,
    }),
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  profession: PropTypes.shape({
    value: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  /* professions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    })
  ), */
  phone: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  confirmationPhone: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  email: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  address: PropTypes.shape({}),
  taxDeclaration: PropTypes.shape({
    value: PropTypes.shape({ chile: PropTypes.bool, world: PropTypes.bool, usa: PropTypes.bool }),
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  previredAuthorization: PropTypes.shape({
    value: PropTypes.bool,
  }),
  isValidPerson: PropTypes.bool,
  canValidate: PropTypes.bool,
  canContinueFlow: PropTypes.bool,
  isLoadingValidatePersonalData: PropTypes.bool,
  onValidatePerson: PropTypes.func,
  onChangeUserData: PropTypes.func,
  onContinueFlow: PropTypes.func,
  onCancelFlow: PropTypes.func,
  onHandleShowModalAfterEvent: PropTypes.func,
};

export default PersonalData;
